import React from "react";
import { IEmailAIExtractedData } from "../../../../types/common";
import { formatDateToString } from "@/utils/date";
import ExtractedDataList from "./ExtractedDataList";
import { Stack, Text } from "@chakra-ui/react";

interface EmailAiExtractedDataDialogProps {
  emailAiExtractedData: IEmailAIExtractedData;
}

const Owners = ({ emailAiExtractedData }: EmailAiExtractedDataDialogProps) => {
  if (!emailAiExtractedData?.owners?.length) return <Text>No owners</Text>;

  const ownersListData = emailAiExtractedData.owners.map((owner, i) => {
    const {
      firstName,
      lastName,
      fullName,
      birthDate,
      mobileNumber,
      emailAddress,
      ownershipPercentage,
      ssn,
      address,
    } = owner;

    return {
      title: `Owner ${i + 1}`,
      listData: [
        { label: "First name", value: firstName },
        { label: "Last name", value: lastName },
        { label: "Birth date", value: formatDateToString(birthDate) },
        { label: "Mobile number", value: mobileNumber },
        { label: "Email adress", value: emailAddress },
        { label: "Adress", value: address },
        { label: "SSN", value: ssn },
        { label: "Ownership", value: `${ownershipPercentage}%` },
      ],
    };
  });

  return (
    <Stack gap={5}>
      {ownersListData?.map((owner) => (
        <Stack>
          <Text>{owner.title}</Text>
          <ExtractedDataList listData={owner.listData} />
        </Stack>
      ))}
    </Stack>
  );
};

export default Owners;
